import { Component, OnInit} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ContactDetailsViewModel } from '../../../models/contact-details-view-model';
import { CreateResult } from '../../../models/create-result';
import { MerchantService } from '../../../services/merchant.service';
import { validateFormHelper } from '../Common-helpers/validate-form';
import { merchantTerminalsLink } from '../../../models/merchant-terminals-link';
import { UserDataStoreService } from '../../../services/user-data-store.service';


@Component({
  selector: 'signup-contact-component',
  templateUrl: './signup-contact.component.html'
})

export class SignupContactComponent extends validateFormHelper implements OnInit {
  
  ContactFormGroup: FormGroup;
  contact: ContactDetailsViewModel = {
    directNumber: '',
    emailAddress: '',
    faxNumber: '',
    firstName: '',
    jobTitle: '',
    merchantNr: '',
    mobileNumber: '',
    surname: '',
    workNumber: '',
    url:''
  };
  public submitted: boolean = false;
  constructor(
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _merchantService: MerchantService,
    private merchantTerminalsLink: merchantTerminalsLink,
    private _userDataStore: UserDataStoreService) {
    super();
  }
  public ngOnInit(): void {
    this.ContactFormGroup = new FormGroup({
      firstName: new FormControl('', Validators.compose([Validators.required])),
      surname: new FormControl('', Validators.compose([Validators.required])),
      emailAddress: new FormControl('', Validators.compose([Validators.required])),
      merchantNr: new FormControl(''),
      mobileNumber: new FormControl('', Validators.compose([Validators.required])),
      workNumber: new FormControl('', Validators.compose([Validators.required])),
      faxNumber: new FormControl(''),
      jobTitle: new FormControl(''),
      url: new FormControl('', Validators.compose([Validators.required])),
    })
  }

  public async setContactData(merchantTypeIdentifier: boolean) {
    debugger;
    if (merchantTypeIdentifier == true) {
      this._ngxUiLoaderService.start();
      var getContacts = await this._merchantService.GetContactDetails(this.merchantTerminalsLink.merchant.merchantNumber, this._userDataStore.selectedParticipant.id.toString());
      debugger;
      if (getContacts != null) {
        var contactEmailAddress = (this.ContactFormGroup.controls['emailAddress'].value != '' && getContacts.emailAddress != this.ContactFormGroup.controls['emailAddress'].value ? this.ContactFormGroup.controls['emailAddress'].value : getContacts.emailAddress);
        this.ContactFormGroup.controls['firstName'].setValue(getContacts.firstName);
        this.ContactFormGroup.controls['surname'].setValue(getContacts.surname);
        this.ContactFormGroup.controls['emailAddress'].setValue(contactEmailAddress);
        this.ContactFormGroup.controls['merchantNr'].setValue(getContacts.merchantNr);
        this.ContactFormGroup.controls['mobileNumber'].setValue(getContacts.mobileNumber);
        this.ContactFormGroup.controls['workNumber'].setValue(getContacts.directNumber);
        this.ContactFormGroup.controls['faxNumber'].setValue(getContacts.faxNumber);
        this.ContactFormGroup.controls['jobTitle'].setValue(getContacts.jobTitle);
        this.ContactFormGroup.controls['url'].setValue(getContacts.url);
        getContacts.emailAddress = contactEmailAddress;
        this.merchantTerminalsLink.contact = getContacts;

        this.disableContactFormControls();
        this._ngxUiLoaderService.stop();
        return;
      }
      else {
        this.enableFormControls();
      }
      this._ngxUiLoaderService.stop();
    }
    this.ContactFormGroup.controls['merchantNr'].setValue(this.merchantTerminalsLink.merchant.merchantNumber);
    this.merchantTerminalsLink.contact = this.ContactFormGroup.value as ContactDetailsViewModel;
  }

  enableFormControls() {
    Object.keys(this.ContactFormGroup.controls).forEach(key => {
      this.ContactFormGroup.controls[key].enable();
    });
  }

  disableContactFormControls() {
    Object.keys(this.ContactFormGroup.controls).forEach(key => {
      if (key != "emailAddress" && key != "url") {
        this.ContactFormGroup.controls[key].disable();
      }

    });
  }

  public async saveAsync(): Promise<CreateResult> {
    return await this._merchantService.AddContactDetails(this.ContactFormGroup.value as ContactDetailsViewModel);
  }

  public async updateContactDetails(ContactDetails: ContactDetailsViewModel): Promise<CreateResult> {
    ContactDetails.emailAddress = this.merchantTerminalsLink.contact.emailAddress;
    return await this._merchantService.UpdateContactDetails(ContactDetails);
  }

  async GetContactDetails(merchantNumber: string, participantId: string) {
    debugger;
    var getResult = await this._merchantService.GetContactDetails(merchantNumber, participantId);
    return getResult;
  }

  public emailValidation(email: string): boolean {
    const regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regexp.test(email);
  }

  async validateForm(): Promise<CreateResult> {
    if (this.ContactFormGroup.valid) {
      var input = this.ContactFormGroup.controls['emailAddress'].value;
      if (input !== null) {
        const emails: string[] = input.trim().split(/[\s,;]+/);
        emails.forEach((value, index) => {
          if (value == ';' || value == ',' || value == '') emails.splice(index, 1);
        });

        for (let i = 0; i < emails.length; i++) {
          var isValid = this.emailValidation(emails[i]);
          if (!isValid) {
            return this.hasValideResponse({ message: `Email : ${emails[i]} is not a valid email`, success: false } as CreateResult);
          }
        }
      }
    }

    return this.formValidation(this.ContactFormGroup, {
      message: "Merchant contact details is invalid, Please fill all required fields",
      success: false
    })
  }
}
